"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
// import app components
const theme_1 = require("../../../theme");
const Sidebar = (props) => {
    const { id, align, children, sx = {}, sidebarWidth = "md", ...rest } = props;
    const getWidth = () => {
        switch (sidebarWidth) {
            case "sm":
                return `${theme_1.SIDEBAR_WIDTH - theme_1.NAV_WIDTH}px`;
            case "md":
                return `${theme_1.SIDEBAR_WIDTH}px`;
            case "lg":
                return `${theme_1.SIDEBAR_WIDTH + theme_1.NAV_WIDTH}px`;
        }
    };
    return (react_1.default.createElement(material_1.Box, { id: id, sx: {
            position: { xs: "fixed", lg: "sticky" },
            top: 0,
            zIndex: { xs: "drawer", lg: "unset" },
            maxWidth: getWidth(),
            left: align === "left" ? 0 : "unset",
            right: align === "right" ? 0 : "unset",
            width: "100%",
            height: "100vh",
            background: theme_1.colors.secondary[850],
            color: theme_1.colors.text[100],
            borderRight: align === "left" ? `1px solid ${theme_1.colors.secondary[600]}` : "none",
            borderLeft: align === "left" ? "none" : `1px solid ${theme_1.colors.secondary[600]}`,
            overflow: "auto",
            transition: "transform 0.3s ease-in-out",
            ...sx,
        }, ...rest }, children));
};
exports.default = Sidebar;
